export default {
  setCondiciones(state, condiciones) {
    state.condiciones = condiciones;
  },

  setCondicion(state, condicion) {
    state.condicionActual = condicion;
  },

  agregarCondicion(state, condicion) {
    state.condiciones.push(condicion);
  },

  actualizarCondicion(state, condicion) {
    const idx = state.condiciones.findIndex(c => c.id === condicion.id);
    if (idx > -1) {
      state.condiciones.splice(idx, 1, condicion);
    }
  },

  eliminarCondicion(state, id) {
    state.condiciones = state.condiciones.filter(c => c.id !== id);
  },

  setHoras(state, horas) {
    state.horas = horas;
  },

  setHora(state, hora) {
    state.horaActual = hora;
  },

  agregarHora(state, hora) {
    state.horas.push(hora);
  },

  actualizarHora(state, hora) {
    const idx = state.horas.findIndex(h => h.id === hora.id);
    if (idx > -1) {
      state.horas.splice(idx, 1, hora);
    }
  },

  eliminarHora(state, id) {
    state.horas = state.horas.filter(h => h.id !== id);
  },

  setLiquidaciones(state, liquidaciones) {
    state.liquidaciones = liquidaciones;
  },

  setLiquidacion(state, liquidacion) {
    state.liquidacionActual = liquidacion;
  },

  agregarLiquidacion(state, liquidacion) {
    state.liquidaciones.push(liquidacion);
  },

  actualizarLiquidacion(state, liquidacion) {
    const idx = state.liquidaciones.findIndex(l => l.id === liquidacion.id);
    if (idx > -1) {
      state.liquidaciones.splice(idx, 1, liquidacion);
    }
    state.liquidacionActual = liquidacion;
  },

  eliminarLiquidacion(state, id) {
    state.liquidaciones = state.liquidaciones.filter(l => l.id !== id);
  },
};
